<template>
  <modal v-if="$root.userLoggedIn" title="Explore Cloudapp Features" @shown="track('viewed_prize_steps')" id="prize-steps-modal" data-testid="prize_steps_modal" :hide-footer="true">
    <iframe :src="iframeUrl"
     class="resp-iframe"
     frameborder="0"
     allowfullscreen
     >
    </iframe>
  </modal>
</template>

<script>
import track from '@/src/tracking';
export default {
  props: {
    iframeUrl: { type: String, required: true }
  },
  methods: {
    track: track
  },
}
</script>

<style lang="scss">
#prize-steps-modal___BV_modal_outer_ {
  .modal-dialog {
    width: 407px;
  }

  iframe {
    width: 100%;
    height: 630px;
    border: none;
  }
}
</style>
